<template>
    <span>£{{ formatted }}</span>
</template>

<script>
export default {
    name: "Currency",

    props: {
        amount: {
            type: [Number, String],
            default: 0,
        },
    },

    computed: {
        formatted() {
            return Number(this.amount).toFixed(2);
        },
    },
};
</script>

<style scoped></style>
